import { InvoiceGuestLogDto } from "./InvoiceGuestLogDto";
import { InvoiceGuestLogModel } from "./InvoiceGuestLogModel";

export const transformInvoiceGuestLogDtoToModel = (
  dto: InvoiceGuestLogDto
): InvoiceGuestLogModel => ({
  ...dto,
  info: dto.info || {},
});
